// src/components/products/FormAddEditProduct.jsx

import React from "react";
import { Box } from "@mui/material";
import ProductFormWrapper from "./ProductForm/ProductFormWrapper";

/**
 * Main Product Form Component
 * Entry point for creating/editing products
 */
const FormAddEditProduct = ({
    currentData = null,
    isEdit = false,
    onSubmitSuccess
}) => {
    return (
        <Box>
            <ProductFormWrapper
                isEdit={isEdit}
                currentData={currentData}
                onSubmitSuccess={onSubmitSuccess}
            />
        </Box>
    );
};

export default FormAddEditProduct;
